import { IdTextModel } from 'common-shared';

export class FilterByHierarchyModel extends IdTextModel {
  NodeIds: string[];
  StatusClv: string;
}
